(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["o-expedition"] && !Shopify.designMode) return;
  try {
    /* Pays de la visiteuse : drapeau et mot changent en silence, sans pop-up, sans redirection ni rechargement. */
  (() => {
    const PAYS = { FR: 'en France', BE: 'en Belgique', CH: 'en Suisse', LU: 'au Luxembourg', MC: 'à Monaco' };
    const COURT = { FR: 'en', BE: 'en', CH: 'en', LU: 'au', MC: 'à' };
    const appliquer = (code) => {
      if (!PAYS[code] || code === 'FR') return;
      document.querySelectorAll('[data-pays]').forEach((el) => {
        const drapeau = el.querySelector('[data-pays-drapeau]');
        if (drapeau) drapeau.src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg?width=32';
        el.querySelector('[data-pays-long]').textContent = PAYS[code];
        const court = el.querySelector('[data-pays-court]');
        court.textContent = COURT[code] + ' ';
        const u = document.createElement('u');
        u.textContent = code;
        court.appendChild(u);
      });
    };
    let memo = null;
    try { memo = sessionStorage.getItem('onyra-pays'); } catch (e) { /* stockage bloqué */ }
    if (memo) return appliquer(memo);
    const racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(racine + 'browsing_context_suggestions.json?country[enabled]=true')
      .then((r) => r.json())
      .then((d) => {
        const code = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!code) return;
        try { sessionStorage.setItem('onyra-pays', code); } catch (e) { /* stockage bloqué */ }
        appliquer(code);
      })
      .catch(() => {});
  })();
  } catch(e) { console.error(e); }
})();

})();
